



























import { Component, Vue } from 'vue-property-decorator'
import { RouteRecord, Route, RawLocation } from 'vue-router'
import axios from '@/server-axios'
import Event from '@/models/event'
import moment from 'moment'

Component.registerHooks([
  'beforeRouteEnter',
  'beforeRouteLeave',
  'beforeRouteUpdate', // for vue-router 2.2+
])

@Component
export default class ViewEvent extends Vue {

    event: Event | null = null

    async beforeRouteEnter(to: Route, from: Route, next:
        (to?: RawLocation | false | ((vm: ViewEvent) => any) | void) => void) {

        if (!axios.defaults.headers.common['Authorization']) {
            const authToken = await Vue.prototype.$auth.getAccessToken()
            axios.defaults.headers.common['Authorization'] = 'Bearer ' + authToken
        }

        try {
            const eventId = to.params.id
            const { data } = await axios.get('events/' + eventId)
            data.at = moment(data.at, 'DD-MM-YYYY hh-mm-ss A')
            next((vm) => {
                vm.event = data
            })
        } catch (e) {
            console.warn(e)
            next(false)
        }

    }

    async beforeRouteUpdate(to: Route, from: Route, next:
        (to?: RawLocation | false | ((vm: ViewEvent) => any) | void) => void) {
            try {
                const data = await this.fetchEvent(to)
                this.event = data
                next()
            } catch (e) {
                console.warn(e)
                next(false)
            }
        }

    async fetchEvent(route: Route) {
        const eventId = route.params.id
        const { data } = await axios.get('events/' + eventId)
        data.at = moment(data.at, 'DD-MM-YYYY hh-mm-ss A')

        return data
    }

    get numberOfAttendees() {
        if (!this.event || !this.event.ratings) {
            return 0
        }
        return this.event.ratings.length
    }

    get peopleTerm() {
        return this.numberOfAttendees === 1 ? 'person' : 'people'
    }

    get formattedDate() {
        if (!this.event) {
            return ''
        }
        return this.event.at.format('MMM DD, YYYY hh:mm A')
    }

    get averageBeer() {
        if (!this.event || !this.event.ratings) {
            return 0
        }

        return (this.event.ratings.reduce((accumulator, currentValue) => accumulator + currentValue.beer, 0)
            / this.event.ratings.length).toFixed(1)
    }

    get averageExperience() {
        if (!this.event || !this.event.ratings) {
            return 0
        }

        return (this.event.ratings.reduce((accumulator, currentValue) => accumulator + currentValue.experience, 0)
            / this.event.ratings.length).toFixed(1)
    }
}
